export const GanttConfig = {
    name            : 'Gantt',
    menuName        : 'Gantt',
    icon            : 'i5-gantchart2',
    image           : 'gantt',
    iconSvg         : 'isvg-view-gantt',
    url             : 'gantt',
    stringId        : 'gantt',
    proOnly         : true,
    description     : 'Plan your work and manage tasks, subprojects and dependencies.',
    inheritance     : true,
    hasTemplates    : true,
    canBeInProject  : true,
}

export const PROJECT_GANTT_CONFIG = {
    ...GanttConfig,
    // key2: "newValue2",  // Replacing the value for key2
}